let tooltiplabels = {}

tooltiplabels.install = function (Vue) {
  Vue.prototype.$tt = (key) => {
    return global.vesteda.settings.filters[key].text || ''
  }
}

export default tooltiplabels;

/*
  0: 'Geschikt voor'
  1: 'Energielabel'
  2: 'Beschikbaarheid'
  3: 'Aantal Slaapkamers'
*/ 

